import './sentry'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils';
import config from './aws-exports'
Amplify.configure(config)

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
